import { FieldProps } from 'lib/iterable-hook-form/FormField/types';
import { Controller } from 'react-hook-form';
import { Checkbox, CheckboxProps } from 'ui/checkboxV2';

type DescribedProps = FieldProps &
  Omit<CheckboxProps, 'status' | 'onClick'> & {
    children?: React.ReactNode;
  };

/**
 * Standard checkbox which displays a checkbox with optional label text
 * @param labelText Text associated to the checkbox, similar to a label
 * @param name Name of field provided for form validation
 * @returns
 */
export const DescribedCheckbox = ({ name, ...rest }: DescribedProps) => {
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <Checkbox {...rest} id={name} name={name} setChecked={onChange} status={value} />
      )}
    />
  );
};
